'use client'

import React from 'react'

import { MapControls } from '@/components/ui/map'
import { cn } from '@/utilities/ui'

type MapContentChromeProps = {
  className?: string
  maxZoom?: number
  minZoom?: number
  onZoomAdjust?: () => void
  zoomInLabel: string
  zoomOutLabel: string
  zoomGroupLabel: string
}

export function MapContentChrome({
  className,
  maxZoom = 14,
  minZoom = 4,
  onZoomAdjust,
  zoomInLabel,
  zoomOutLabel,
  zoomGroupLabel,
}: MapContentChromeProps) {
  return (
    <MapControls
      className={cn('pointer-events-auto z-[3]', className)}
      maxZoom={maxZoom}
      minZoom={minZoom}
      onZoomAdjust={onZoomAdjust}
      position="bottom-right"
      showCompass={false}
      showFullscreen={false}
      showLocate={false}
      zoomGroupLabel={zoomGroupLabel}
      zoomInLabel={zoomInLabel}
      zoomOutLabel={zoomOutLabel}
    />
  )
}
